<script setup lang="ts">
import './assets/style.scss'
import { computed } from 'vue'
import { AcceptStatus } from './../model/types.ts'

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
})

const statusItem = computed(() => AcceptStatus[props.status])
</script>

<template>
  <div
    class="v-invent-accept-status"
    :style="{
      color: `rgba(${statusItem.color}, 1)`,
      backgroundColor: `rgba(${statusItem.color}, 0.2)`,
    }"
  >
    {{ statusItem.name }}
  </div>
</template>
